/**
 * A unidade escolhida na topbar — trilha T7.
 *
 * Módulo à parte, como `clinicaAtiva.ts`: os adaptadores leem isto a cada
 * consulta, e a sessão já importa os adaptadores.
 *
 * Unidade é dimensão DENTRO da clínica (regra inviolável 2). Escolher uma
 * recorta a agenda, os atendimentos e as contas na tela; não muda acesso — o
 * isolamento continua sendo por clínica na RLS, e nada disto vai ao banco.
 *
 * A escolha vale para a sessão do navegador (sobrevive a recarregar a página)
 * e só para a clínica em que foi feita: trocar de clínica volta para "Todas".
 */

const CHAVE = 'vec.unidade';

/** Avisa quem mostra unidades (o seletor) que a lista mudou. */
export const EVENTO_DAS_UNIDADES = 'vecchia:unidades-mudaram';

let ativa: string | null = null;

/** A unidade escolhida, ou `null` para "Todas as unidades". */
export function unidadeAtiva(): string | null {
    return ativa;
}

export function definirUnidadeAtiva(id: string | null): void {
    ativa = id;
}

/** A unidade guardada nesta sessão do navegador, se foi escolhida NESTA clínica. */
export function unidadeGuardada(clinicaId: string | null): string | null {
    if (!clinicaId) return null;
    try {
        const guardada = JSON.parse(sessionStorage.getItem(CHAVE) ?? 'null') as { clinicaId?: unknown; unidadeId?: unknown } | null;
        return guardada?.clinicaId === clinicaId && typeof guardada.unidadeId === 'string' ? guardada.unidadeId : null;
    } catch {
        /* Sem armazenamento, ou valor ilegível: vale "Todas as unidades". */
        return null;
    }
}

export function guardarUnidade(clinicaId: string | null, id: string | null): void {
    try {
        if (clinicaId && id) sessionStorage.setItem(CHAVE, JSON.stringify({ clinicaId, unidadeId: id }));
        else sessionStorage.removeItem(CHAVE);
    } catch {
        /* A escolha vale só até recarregar. */
    }
}

export function avisarQueAsUnidadesMudaram(): void {
    window.dispatchEvent(new Event(EVENTO_DAS_UNIDADES));
}
